import {z} from 'zod';

import {optionalHexColour, optionalText} from './catalogueUi';
import {optionalMoneyInput, priceInput} from './moneyInput';

export const upholsterySchema = z.object({
  name: z.string().min(1),
  fabric: optionalText,
  factoryCode: optionalText,
  hex: optionalHexColour,
  priceNet: priceInput,
  costNet: optionalMoneyInput,
});
